import { put, takeLatest, cancelled } from 'redux-saga/effects';
import { environmentIndicatorActions as actions } from '.';
import { authProviderActions } from '../../AuthProvider/slice';

function* resetDemo() {
  try {
    yield put(authProviderActions.loadUserDataRequest());
    yield put(actions.resetDemoSuccess());
  } catch (error) {
    yield put(actions.resetDemoFailed(error.payload));
  } finally {
    if (yield cancelled()) {
    }
  }
}

export function* environmentIndicatorSaga() {
  yield takeLatest(actions.resetDemoRequest.type, resetDemo);
}
